
(function () {
  'use strict';
  
  /**
   * @ngdoc service
   * @name vcdms.vcpdfprinter.factory:PdfprinterHelper
   *
   * @description
   *
   */
  angular
    .module('vcdms.vcpdfprinter')
    .factory('PdfprinterHelper', PdfprinterHelper);
  
  
  PdfprinterHelper.$inject = ['Pdfprinter', '$uibModal', '$log', 'Rlog'];
  
  function PdfprinterHelper(Pdfprinter, $uibModal, $log, Rlog) {
    let PdfprinterHelperBase = {};
    
    PdfprinterHelperBase.editPdfprinter = editPdfprinter;
    PdfprinterHelperBase.addPdfprinter = addPdfprinter;
    
    
    function addPdfprinter(success, error) {
      let dialog = $uibModal.open({
        template: '<div class="modalspacer"><pdfprinterform pdfprinter="vm.pdfprinter" parentsave="vm.childsave(pdfprinter)" oncancel="vm.cancel()"></pdfprinternew></div>',
        controllerAs: 'pdfprinteraCtrl',
        controller: ['pdfprinter', function () {
          let vm = this;
          vm.pdfprinter = {};
          
          vm.childsave = childsave;
          vm.cancel = cancel;
          
          function childsave(pdfprinter) {
            Pdfprinter.$create(pdfprinter).$then(function (newpdfprinter) {
              vm.created = true;
              success(newpdfprinter);
              dialog.close();
            }, function (err) {
              vm.created = false;
              $log.error('Creation of new SV failed @ pdfprinter-helper.addPdfprinter: ', err);
              Rlog.error('vcutils.pdfprinter', 'pdfprinter-helper.addPdfprinter', 'Creation of new pdfprinter failed: ', {pdfprinter: pdfprinter});
              dialog.close();
            });
          }
          
          function cancel() {
            dialog.close();
          }
          
        }],
        resolve: {
          pdfprinter: function () {
            return {};
          }
        },
        size: 'lg'
      });
    }
    
    
    function editPdfprinter(lpdfprinter) {
      let dialog = $uibModal.open({
        template: '<div class="modalspacer"><pdfprinterform pdfprinter="pdfprintereCtrl.pdfprinter" parentsave="pdfprintereCtrl.childsave(pdfprinter)" oncancel="pdfprintereCtrl.cancel()"></pdfprinterform></div>',
        controllerAs: 'pdfprintereCtrl',
        controller: ['pdfprinter', function (spdfprinter) {
          let vm = this;
          vm.pdfprinter = spdfprinter;
          vm.childsave = childsave;
          vm.cancel = cancel;
          
          
          function childsave(pdfprinter) {
            // vm.pdfprinter = angular.copy(pdfprinter);
            // the abouve code threw an restmod error, despite actually saving
            // the below variant does not raise an error
            for (let key in pdfprinter) {
              if (pdfprinter.hasOwnProperty(key)) {
                vm.pdfprinter[key] = pdfprinter[key];
              }
            }
            
            if (vm.pdfprinter.$hasPendingActions()) {
              vm.pdfprinter.$cancel();
              vm.pdfprinter.$save();
              cancel();
            }
            else {
              vm.pdfprinter.$save();
              dialog.close();
            }
          }
          
          
          function cancel() {
            dialog.close();
          }
          
          
        }],
        resolve: {
          pdfprinter: function () {
            return lpdfprinter;
          }
        },
        size: 'lg'
      });
      return dialog;
    }
    
    return PdfprinterHelperBase;
  }
}());
